import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../context/AuthContext";

/**
 * Nur die Rolle `admin` — anders als `RequireAuth adminOnly`, das auch `gfgl`
 * durchlässt. Innerhalb von `RequireAuth` verwenden (Login/Laden prüft dort).
 */
const NurAdmin: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/access-denied" replace />;
};

export default NurAdmin;
